import {LogicSearch, OperatorSearch, SortType, TypeFieldSearch} from "./vss-ui.enum";
import {Observable, of} from "rxjs";
import {InjectionToken} from "@angular/core";
import {NzTreeNodeOptions} from "ng-zorro-antd/tree";


export interface OptionModel {
  value: any;
  label: string;
  shortCode?: string;
  class?: string;
  color?: string;
  disabled?: boolean;
  children?:OptionModel[],
}
export interface PagingModel {
  pageIndex:number;
  pageSize:number;
  totalPages:number;
  totalElements:number;
}

export interface BaseConditionSearchModel {
  property: string // field name
  propertyType: TypeFieldSearch,
  operator: OperatorSearch,
  value: any
}

export interface ConditionSearchModel extends Partial<BaseConditionSearchModel>{
  expType?: LogicSearch
  lstCondition?: ConditionSearchModel[]
}

export interface SortSearchModel {
  fieldName: string
  sort: SortType
}

export interface configSelectItemModel {
  /***
   *  example
   * *    getDefaultQuestionGroup = (values: any[]) => {
   * *       return this.questionGroupApi.getDetailQuestionGroup(values)
   * *         .pipe(
   * *           map(res => {
   * *             return res.data?.map((x: any) => ({ value: x.id , label:`${x.title }`, totalPages: res.data.totalPages, ...x })) || []
   * *           })
   * *         )
   * *     }
   ***/
  getOptionsDefaultApi?: ((valuesSelected: any[]) => Observable<any>)
  /***
   *  example
   *  *   pros params bao gồm :
   *  *   keyword: là từ khóa khi tìm kiếm ở selectbox
   *  *   page: trang hiện tại
   *  *   size: số dòng trên 1 trang
   *  *   ...selectOptionsQueryParams: là params truyền vào ở thẻ <vss-ui-select-box [selectOptionsQueryParams]></vss-ui-select-box>
   * *   lstCampaign = (params: any) => {
   *  *      const searchParams = {
   *  *        ...params,
   *  *        isActive: 0,
   *  *        name: params.keyword
   * *       }
   *  *      return this.customerAllocationApi.searchCampaign(searchParams)
   *  *        .pipe(
   *  *          map(res => res.data?.content?.map((x: any) => ({ ...x, value: x.id, label: `${x.code} - ${x.name}`, totalPages: res.data.totalPages }))),
   *  *          finalize(() => this.viewCsSelect.isLoading = false),
   *  *        )
   * *     }
   ***/
  apiStreamSearch?: ((params: any) => Observable<any[]>)
  /***
   *  example
   * *  lstCampaign = () => {
   * *       return this.customerAllocationApi.searchCampaign(searchParams)
   * *         .pipe(
   * *           map(res => res.data?.content?.map((x: any) => ({ ...x, value: x.id, label: `${x.code} - ${x.name}`, totalPages: res.data.totalPages }))),
   * *         )
   * *     }
   ***/
  apiGetOptions?: ((params: any) => Observable<any[]>)
  // getOptionsApi?: ((params: OptionModel) => Promise<any[]>) | undefined
  optionList?: any[]
  isMultiLevel?: boolean
}

export interface configSelectModel {
  [key:string]: configSelectItemModel
}

export interface configAddressSelectItemModel {
  /***
   *  example
   **  params sẽ là 1 Object chứa referenceId phụ thuộc theo AddressType và các tham số có trong referenceObject của AddressSelectorDirective
   ** lstCampaign = (params: any) => {
   **
   **     return this.locationApi.getCommunes({
   **         districtId: params.referenceId,
   **       })
   **       .pipe(
   **         map(res => res.data?.content?.map((x: any) => ({ ...x, value: x.id, label: `${x.code} - ${x.name}`, totalPages: res.data.totalPages }))),
   **       )
   **   }
   ***/
  apiGetOptions: ((params: any) => Observable<any[]>)
}

export interface configAddressSelectModel {
  country?: configAddressSelectItemModel
  province?: configAddressSelectItemModel
  district?: configAddressSelectItemModel
  commune?: configAddressSelectItemModel
  areaStore?: configAddressSelectItemModel,
  provinceStore?: configAddressSelectItemModel
  districtStore?: configAddressSelectItemModel,
  communeStore?: configAddressSelectItemModel,
}
export class VssUiConfig {
  configSelectBox?: configSelectModel = {}
  configAddressSelectBox?: configAddressSelectModel = {}
  uploadService$?: ((files: File[], params?: any) => Observable<any>) = (files, params) => of()
  urlAdmin: string = ''
  roleAdmin = 'ROLE_ADMIN'
  contextPathBase:string = '/api/v1/admin'
  url403?: string = '/error/403'
  messageError401?: string = 'Token has expired!'
  showApiMessageError?: boolean = true
  decimalChar: ',' | '.' = '.'
  rangesDate?: { [ key: string ]: Date[] } | { [ key: string ]: () => Date[] }
  mapKeyApiError?: any = {
    positionCode: 'Mã chức danh',
    positionName: 'Tên chức danh',
  }
}

export interface TreeNodeOptionsModel extends NzTreeNodeOptions{
  rulesContextMenu?: {
    ruleEdit?: string[]
    ruleCopy?: string[]
    ruleDelete?: string[]
  }
}
export interface FileInfoModel {
  fileName: string,
  filePath: string,
  id: number,
  isActive: boolean
}
